import { render, staticRenderFns } from "./MatterMediationForm.vue?vue&type=template&id=701f1891&"
import script from "./MatterMediationForm.vue?vue&type=script&lang=js&"
export * from "./MatterMediationForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterMediationForm.vue?vue&type=style&index=0&id=701f1891&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports